<div class="container card mt-3 p-3">
  <!-- Warning if campaign is in progress -->
  <div *ngIf="campaign?.isInProgress" class="warning-text">
    This campaign is in progress, you can't edit it right now!
  </div>

  <!-- Header -->
  <div class="card-header d-inline-flex">
    <h3>Campaign name: {{ campaign?.campaignName }}</h3>
    <button
      class="btn btn-secondary d-flex align-items-center mb-3 ms-auto"
      (click)="goBack()"
    >
      <span class="material-icons me-1" title="Go Back">arrow_left</span>
      <span class="font-medium">Back</span>
    </button>
  </div>

  <!-- Main Content -->
  <div class="card-body bg-blue-50" *ngIf="!campaign?.isInProgress">
    <!-- Add Phase Button -->
    <div class="mb-3">
      <button
        class="btn btn-success d-flex align-items-center"
        (click)="showAddPhase()"
        *ngIf="!showAddPhaseForm"
      >
        <i class="pi pi-plus me-2"></i>
        <span>Add Phase</span>
      </button>
    </div>

    <!-- Add/Edit Phase Form -->
    <div class="card p-3 mb-3" *ngIf="showAddPhaseForm">
      <h5 class="mb-3">{{ editingPhase ? "Edit Phase" : "Add New Phase" }}</h5>

      <div class="row mb-2">
        <div class="col-md-6">
          <label class="form-label">Phase name *</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="newPhaseName"
            placeholder="e.g., Default Phase"
          />
        </div>
        <div class="col-md-3">
          <label class="form-label">Phase order</label>
          <input
            type="number"
            class="form-control"
            [(ngModel)]="newPhaseOrder"
            min="1"
          />
          <small class="text-muted">Order: 1 = first phase</small>
        </div>
        <div class="col-md-3 d-flex align-items-end gap-2">
          <button
            class="btn btn-primary"
            (click)="editingPhase ? updatePhase() : createPhase()"
          >
            {{ editingPhase ? "Update" : "Create" }}
          </button>
          <button class="btn btn-secondary" (click)="hideAddPhase()">
            Cancel
          </button>
        </div>
      </div>
    </div>

    <!-- Phases List -->
    <div class="mb-3">
      <div *ngFor="let phase of phases" class="mb-3 phase-card">
        <p-accordion>
          <p-accordion-panel value="0">
          <p-accordion-header>{{ phase.phaseName }}</p-accordion-header>
          <p-accordion-content>
            <div class="card-body">
              <div class="mb-2 row justify-content-end g-2">
                <div class="col-auto">
                  <button
                    class="btn btn-outline-primary"
                    (click)="editPhase(phase)"
                  >
                    <i class="pi pi-pencil"></i>
                  </button>
                </div>
                <div class="col-auto">
                  <button
                    class="btn btn-outline-danger"
                    (click)="deletePhase(phase)"
                  >
                    <i class="pi pi-trash"></i>
                  </button>
                </div>
              </div>

              <div class="row">
                <app-channel-details
                  *ngFor="let cfg of channelConfigs"
                  [config]="cfg"
                  [phase]="phase"
                  [campaignData]="campaignData"
                  [channels]="getPhaseChannels(phase, cfg.typeSuffix)"
                  [nextChannelNumber]="
                    getNextChannelNumber(phase, cfg.typeSuffix)
                  "
                  (removeTemplate)="
                    removeTemplateFromPhase(
                      $event.phase,
                      $event.channelId,
                      $event.type
                    )
                  "
                  (plannedDateChange)="
                    setTemplatePlannedDate($event.channel, $event.event)
                  "
                  (templateConnected)="
                    addTemplateToPhase($event.phase, $event.type, $event.template)
                  "
                ></app-channel-details>
              </div>
            </div>
          </p-accordion-content>
          </p-accordion-panel>
        </p-accordion>
      </div>
    </div>

    <!-- No Phases Message -->
    <div *ngIf="phases.length === 0" class="text-center text-muted py-5">
      <i class="pi pi-folder-open" style="font-size: 3rem"></i>
      <p class="mt-3">No phases yet. Click "Add Phase" to create one.</p>
    </div>
  </div>

  <!-- Loading Spinner -->
  <p-dialog
    [(visible)]="loading"
    [modal]="true"
    [closable]="false"
    [dismissableMask]="false"
    [baseZIndex]="4"
    showHeader="false"
    styleClass="spinner-dialog"
  >
    <div class="spinner-content">
      <p-progress-spinner></p-progress-spinner>
      <div class="spinner-label"></div>
    </div>
  </p-dialog>
</div>
